import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import {
  type CodigoServico,
  type CodigosServicoResponse,
  fetchCodigosServico,
} from '~/api/clients';
import { queryKeys } from '~/api/queryKeys';

const CODIGOS_STALE_TIME_MS = 5 * 60_000;

export const ALIQUOTA_ORIGEM_PADRAO: CodigoServico['aliquota_origem'] = 'PADRAO';

export const AVISO_ALIQUOTA_PADRAO =
  'A cidade da empresa não tem alíquota de ISS cadastrada para este serviço; a alíquota abaixo é a padrão do código. Confira antes de emitir.';

export function isAliquotaPadrao(codigo: CodigoServico): boolean {
  return codigo.aliquota_origem === ALIQUOTA_ORIGEM_PADRAO;
}

export function parseAliquota(aliquotaIss: string): number | undefined {
  const numeric = Number.parseFloat(aliquotaIss);
  return Number.isFinite(numeric) ? numeric : undefined;
}

export function useCodigosServicoQuery(
  clientId: number | undefined,
): UseQueryResult<CodigosServicoResponse> {
  return useQuery({
    queryKey: queryKeys.codigosServico(clientId ?? null),
    queryFn: () => {
      if (!clientId) throw new Error('clientId obrigatório');
      return fetchCodigosServico(clientId);
    },
    enabled: typeof clientId === 'number',
    staleTime: CODIGOS_STALE_TIME_MS,
  });
}
